var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,25.000000) scale(0.004883,-0.004883)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2365 4583 c-264 -24 -567 -120 -806 -255 -846 -478 -1232 -1489 -923 -2418 99 -298 261 -558 488 -786 384 -383 891 -594 1434 -594 789 0 1495 445 1839 1160 57 120 126 325 152 455 136 684 -67 1365 -553 1851 -331 331 -753 533 -1218 583 -91 10 -322 12 -413 4z m395 -228 c541 -64 1005 -348 1306 -800 401 -602 401 -1388 0 -1990 -263 -395 -658 -666 -1117 -769 -396 -88 -806 -40 -1175 139 -497 241 -857 696 -978 1236 -161 724 142 1475 763 1891 358 239 782 343 1201 293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395 3944 c-16 -3 -75 -14 -129 -25 -607 -126 -1061 -656 -1093 -1276 l-6 -122 36 -36 c29 -29 42 -35 77 -35 34 0 48 6 76 34 28 28 34 41 34 78 0 152 49 359 119 503 271 556 928 809 1491 575 123 -51 196 -25 207 74 5 42 3 48 -28 79 -41 41 -162 89 -309 124 -84 19 -139 25 -275 28 -93 2 -183 1 -200 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3575 3724 c-16 -8 -203 -188 -415 -399 l-385 -384 -70 24 c-284 98 -575 -107 -575 -405 0 -239 191 -430 430 -430 298 0 503 290 405 575 l-24 70 394 395 c344 345 394 400 400 433 9 49 -10 94 -49 118 -38 23 -71 24 -111 3z m-909 -989 c133 -78 131 -273 -4 -352 -179 -105 -385 99 -279 279 60 102 180 133 283 73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3693 3203 c-32 -6 -72 -51 -79 -89 -5 -26 2 -55 29 -121 52 -134 86 -298 87 -426 0 -42 5 -54 34 -83 28 -28 42 -34 76 -34 34 0 48 6 76 34 33 33 34 37 34 109 0 151 -42 355 -102 494 -41 96 -85 128 -155 116z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.ff79db40d63d632a05dbe662fc5497bc.svg";
export { ForwardRef as ReactComponent };